import PropTypes from 'prop-types';
import React from 'react';

import staticURL from 'lib/staticURL';
import UpgradeAccountModal from 'start/upgrade-account/UpgradeAccountModal';

import NotificationBanner from './NotificationBanner';

export default function UpgradeAccountBanner({onCloseBanner}) {
  return (
    <NotificationBanner
      onCloseBanner={onCloseBanner}
      imageURL={staticURL('/static/img/upgrade_account.png')}
      title="Want to get more out of Benchling?"
    >
      <div>
        <a onClick={() => UpgradeAccountModal.open()}>Upgrade your Benchling account</a>
      </div>
      to get enterprise-grade security, witness & review, workflow management, sample tracking, and more.
    </NotificationBanner>
  );
}

UpgradeAccountBanner.propTypes = {
  onCloseBanner: PropTypes.func.isRequired,
};
